import { render, staticRenderFns } from "./FacebookPostMatch.vue?vue&type=template&id=7aa87e66&scoped=true&"
import script from "./FacebookPostMatch.vue?vue&type=script&lang=js&"
export * from "./FacebookPostMatch.vue?vue&type=script&lang=js&"
import style0 from "./FacebookPostMatch.vue?vue&type=style&index=0&id=7aa87e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa87e66",
  null
  
)

export default component.exports